import { createFileRoute } from '@tanstack/react-router';
import { Alert } from '@osd/ui/alert';
import { Stack } from '@osd/ui/stack';
import { CodeBlock } from '@osd/ui/code-block';
import { Section } from '@osd/ui/section';

/**
 * /ui/alert — live docs for the `Alert` primitive.
 */
export const Route = createFileRoute('/ui/_layout/alert')({
  component: AlertPage,
});

function AlertPage() {
  return (
    <Stack gap={6}>
      <Section title="Alert" hint="info | success | warning | danger">
        <Stack gap={2}>
          <Alert variant="info">An informational message.</Alert>
          <Alert variant="success">Saved successfully.</Alert>
          <Alert variant="warning">This action cannot be undone.</Alert>
          <Alert variant="danger">Invalid email or password.</Alert>
        </Stack>
      </Section>

      <Section title="Code example" hint="copy-pasteable usage">
        <Stack gap={5}>
          <CodeBlock
            title="Default — info variant"
            hint='Default variant is "info" if you omit the prop'
            language="tsx"
            code={`<Alert variant="info">An informational message.</Alert>`}
          />

          <CodeBlock
            title="All four variants"
            hint="Variants drive both the icon and the colour"
            language="tsx"
            code={`<Alert variant="info">An informational message.</Alert>
<Alert variant="success">Saved successfully.</Alert>
<Alert variant="warning">This action cannot be undone.</Alert>
<Alert variant="danger">Invalid email or password.</Alert>`}
          />
        </Stack>
      </Section>
    </Stack>
  );
}
